<template>
    <div class="row">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto">
            <div class="card ">
                <div class="card-header">
                    <h4 class="card-title text-left">TaxRate</h4>
                    <div class="row">
                        <div class="col-md-5 col-lg-5 pb-3">
                            <div class="form-group">
                                <label></label>
                                <input type="text" class="form-control" v-model="searchQuery" name="search" id="search" placeholder="Search by TaxRate Name" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="col-lg-12">
                        <div class="col-md-12 text-left">
                            <a href="javascript:void(0)" class="btn btn-outline-primary btn-round " v-on:click="openmodel"><i class="fa fa-plus"></i> Add New</a>
                        </div>
                        <div class="mt-2">
                            <div>
                                <table class="table table-shopping">
                                    <thead class="">
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                Name
                                            </th>
                                            <th>
                                                Code
                                            </th>
                                            <th>
                                                Description
                                            </th>


                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(taxRate,index) in resultQuery" v-bind:key="taxRate.id">
                                            <td>
                                                {{index+1}}
                                            </td>

                                            <td>
                                                <strong>
                                                    <a href="javascript:void(0)" v-on:click="EditTaxRate(taxRate.id)">{{taxRate.name}}</a>
                                                </strong>
                                            </td>
                                            <td>
                                                {{taxRate.code}}
                                            </td>
                                            <td>
                                                {{taxRate.description}}
                                            </td>


                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <taxratemodel :taxRate="newTaxRate"
                     :show="show"
                     v-if="show"
                     @close="show = false"
                     :type="type" />

    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                searchQuery: '',
                show: false,
                taxRatelist: [],
                newTaxRate: {
                    id: '',
                    name: '',
                    description: '',
                    code: '',
                    rate: 0,
                    isActive: true
                },
                type: '',
            }
        },
        computed: {
            resultQuery: function () {
                var root = this;
                if (this.searchQuery) {
                    return this.taxRatelist.filter((taxRate) => {
                        return root.searchQuery.toLowerCase().split(' ').every(v => taxRate.name.toLowerCase().includes(v))
                    })
                } else {
                    return root.taxRatelist;
                }
            },
        },
        methods: {
            openmodel: function () {
                this.newTaxRate = {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '',
                    description: '',
                    code: '',
                    rate:0,
                    isActive: true
                }
                this.show = !this.show;
                this.type = "Add";
            },
            GetTaxRateData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('Product/TaxRateList', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.$store.dispatch('GetTaxRateList', response.data.taxRates);
                        root.taxRatelist = response.data.taxRates;
                    }
                });
            },
            EditTaxRate: function (Id) {
                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Product/TaxRateDetail?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data) {
                             //eslint-disable-line
                            root.newTaxRate.id = response.data.id;
                            root.newTaxRate.name = response.data.name;
                            root.newTaxRate.rate = response.data.rate;
                            root.newTaxRate.description = response.data.description;
                            root.newTaxRate.code = response.data.code;
                            root.newTaxRate.isActive = response.data.isActive;
                            root.show = !root.show;
                            root.type = "Edit"
                        } else {
                            console.log("error: something wrong from db.");
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });

            }
        },
        mounted: function () {
            this.GetTaxRateData();
        }
    }
</script>